export const PRIMARY_COLOR = '#FF5800';
export const ACCENT_COLOR = '#053F5C';

/**
 * Deep Orange — the brand's destructive/error shade (`--IA-orange-deep` / `--destructive` in the
 * platform-web design system). Deliberately distinct from `PRIMARY_COLOR`, so an ended-badly state
 * does not render as the primary CTA orange. Not red: the brand has no red. Kept here because
 * `Color` from `@intelliarts/react-components` does not expose the extended ramp yet.
 */
export const DESTRUCTIVE_COLOR = '#E23600';

export const getContrastTextColor = (hex: string): string => {
  if (!hex || !hex.startsWith('#') || hex.length < 7) return '#000000';

  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const d = max - min;

  let h = 0;
  if (d !== 0) {
    switch (max) {
      case r: h = ((g - b) / d % 6) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
    }
    if (h < 0) h += 1;
  }

  return `hsl(${Math.round(h * 360)}, 70%, 25%)`;
};
